<div class="space-y-6">
  <div class="flex items-center justify-between">
    <app-page-headline
      [headline]="'pages.uploads.headline' | translate"
      [isLoading]="isLoading"
      [count]="total"
    />
    <app-button
      data-test-id="uploadButton"
      type="primary"
      routerLink="/uploads/upload-file"
    >
      <svg-icon class="size-5" src="assets/icons/General/upload-01.svg" />
      {{ 'pages.uploads.uploadButton.label' | translate }}
    </app-button>
  </div>

  <div class="flex flex-col gap-6">
    <div class="flex flex-row gap-6">
      <app-value-filter
        data-test-id="stateFilter"
        [selected]="activeState"
        [isLoading]="isLoading"
        [options]="valueFilterOptions"
        (selectionChange)="onStateFilterChange($event)"
      />
    </div>

    <app-branch-base
      [isLoading]="isLoading"
      [sword]="sword"
      [tableData]="tableData"
      [total]="total"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [activeSorting]="activeSorting"
      [tableColumns]="[
        {
          key: 'actions',
          label: 'pages.uploads.table.actions.label' | translate,
          width: '60px',
          align: 'right',
          fixRight: true,
          cellTemplate: actionCellTemplate,
          sort: false,
        },
      ]"
      [customNoResultText]="'pages.uploads.table.noResultText' | translate"
      (changeHandler)="changeTableHandler($event)"
    />
  </div>
</div>

<ng-template
  #actionCellTemplate
  let-currentRow="currentRow"
  [typedTemplate]="typeToken"
>
  <app-button
    class="inline-block"
    data-test-id="viewButton"
    type="primary"
    shape="circle"
    [disabled]="
      currentRow.processState === 'UPLOAD_FAILED' ||
      currentRow.state === 'WORKFLOW_INITIAL'
    "
    [title]="'pages.uploads.table.actions.view.title' | translate"
    [routerLink]="['upload-detail', currentRow.id]"
  >
    <svg-icon src="assets/icons/General/eye.svg" />
  </app-button>
</ng-template>
